// extracted by mini-css-extract-plugin
module.exports = {"feedback":"feedback-module--feedback--1_DLs"};